import { render, staticRenderFns } from "./StatusWidgets.vue?vue&type=template&id=a35504bc&scoped=true&"
import script from "./StatusWidgets.vue?vue&type=script&lang=js&"
export * from "./StatusWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35504bc",
  null
  
)

export default component.exports